import { Box, BoxProps } from "@chakra-ui/react";

function SuperAdminPlaceholderIcon({ ...props }: BoxProps) {
  return (
    <Box {...props}>
      <svg
        width="100"
        height="100"
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M86.558 75C89.6801 75 92.1634 73.0353 94.3931 70.2881C98.9575 64.6644 91.4634 60.1702 88.6052 57.9692C85.6996 55.7317 82.4554 54.4642 79.1662 54.1667M74.9995 45.8333C80.7525 45.8333 85.4162 41.1696 85.4162 35.4167C85.4162 29.6637 80.7525 25 74.9995 25"
          stroke="#1819B4"
          stroke-width="6.25"
          stroke-linecap="round"
        />
        <path
          d="M13.4412 75C10.3191 75 7.83583 73.0353 5.60616 70.2881C1.04175 64.6644 8.53584 60.1702 11.3941 57.9692C14.2996 55.7317 17.5438 54.4642 20.833 54.1667M22.9164 45.8333C17.1634 45.8333 12.4997 41.1696 12.4997 35.4167C12.4997 29.6637 17.1634 25 22.9164 25"
          stroke="#1819B4"
          stroke-width="6.25"
          stroke-linecap="round"
        />
        <path
          d="M33.682 62.9659C29.4246 65.5984 18.2619 70.9738 25.0607 77.7002C28.3819 80.986 32.0808 83.3359 36.7312 83.3359H63.2677C67.9181 83.3359 71.6171 80.986 74.9382 77.7002C81.737 70.9738 70.5744 65.5984 66.317 62.9659C56.3334 56.7926 43.6655 56.7926 33.682 62.9659Z"
          stroke="#1819B4"
          stroke-width="6.25"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M64.5828 31.2474C64.5828 39.3015 58.0536 45.8307 49.9995 45.8307C41.9453 45.8307 35.4161 39.3015 35.4161 31.2474C35.4161 23.1932 41.9453 16.6641 49.9995 16.6641C58.0536 16.6641 64.5828 23.1932 64.5828 31.2474Z"
          stroke="#1819B4"
          stroke-width="6.25"
        />
      </svg>
    </Box>
  );
}

export { SuperAdminPlaceholderIcon };
